const LOGO_URL =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35"><rect width="35" height="35" rx="7" fill="%231c4b82"/><text x="17.5" y="23" text-anchor="middle" font-family="Arial, sans-serif" font-size="17" font-weight="700" fill="%23ffffff">T</text></svg>';

// ==============================|| LOGO ICON IMAGE ||============================== //

export default function LogoIcon() {
  return (
    <img
      src={LOGO_URL}
      alt="Termoplast"
      width="35"
      height="35"
      loading="eager"
      style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}
    />
  );
}
